import { createContext, useContext } from 'react';
import { Box, MenuItem, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import CheckIcon from '@mui/icons-material/Check';
import { RISK_GRADES, gradeLabel } from '../../../utils/assessmentMode';

export const AssessmentModeContext = createContext('score');

export function AssessmentModeSelect({ value, onChange, disabled, gradeAvailable }) {
  return <ToggleButtonGroup exclusive value={value || 'score'} disabled={disabled}
    aria-label="프로젝트 평가 방식" className="assessment-mode-select"
    onChange={(_, next) => { if (next) onChange(next); }}>
    <ToggleButton value="score" aria-label="점수 평가"><GridOnOutlinedIcon fontSize="small" />점수 평가</ToggleButton>
    <ToggleButton value="grade" aria-label="상·중·하 평가" disabled={disabled || !gradeAvailable}>
      <FormatListBulletedIcon fontSize="small" />상·중·하 평가
    </ToggleButton>
  </ToggleButtonGroup>;
}

export function RiskValue({ score, grade, prefix = '', description }) {
  const mode = useContext(AssessmentModeContext);
  return <span>{prefix}{mode === 'grade' ? gradeLabel(grade) || '-' : Number(score) > 0 ? `${score}점` : '-'}
    {mode !== 'grade' && description && ` · ${description}`}</span>;
}

export function GradeSelect({ value, onChange, colors, disabled = false, label = '위험성 등급' }) {
  return <ToggleButtonGroup value={value || null} exclusive disabled={disabled} fullWidth
    size="small" aria-label={label} onClick={event => event.stopPropagation()}
    onChange={(_, next) => onChange(next ?? '')}
    sx={{ p: '3px', gap: '3px', border: '1px solid', borderColor: 'divider', borderRadius: '6px', bgcolor: 'background.paper',
      '& .MuiToggleButtonGroup-grouped': { border: '0 !important', borderRadius: '4px !important', m: '0 !important', minWidth: 0 },
      '& .MuiToggleButton-root': { minHeight: { xs: 44, lg: 36 }, px: 0.5, gap: 0.75, fontWeight: 500, color: 'text.secondary',
      '&.Mui-selected, &.Mui-selected.Mui-disabled': { bgcolor: 'action.selected', color: 'text.primary', boxShadow: 'inset 0 0 0 1px var(--grade-accent)' },
        '&.Mui-disabled': { color: 'text.secondary' }, '&.Mui-focusVisible': { outline: '2px solid', outlineColor: 'primary.main' } } }}>
    {RISK_GRADES.map(grade => {
      return <ToggleButton key={grade.value} value={grade.value} aria-label={`${label} ${grade.label}`}
        style={{ '--grade-accent': colors?.[grade.value] || grade.color }}>
        <Box component="span" aria-hidden="true" sx={{ width: 16, height: 16, display: 'grid', placeItems: 'center' }}>
          {value === grade.value ? <CheckIcon sx={{ fontSize: 16 }} /> :
            <Box component="span" sx={{ width: 6, height: 6, bgcolor: 'var(--grade-accent)', borderRadius: '50%' }} />}
        </Box>{grade.label}
      </ToggleButton>;
    })}
  </ToggleButtonGroup>;
}

export function AfterRiskInput({ value, onChange, disabled = false }) {
  const mode = useContext(AssessmentModeContext);
  if (mode === 'grade') return <TextField select fullWidth size="small" label="개선 후 위험성" disabled={disabled}
    value={value || ''} onChange={event => onChange(event.target.value)}>
    {RISK_GRADES.map(item => <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>)}
  </TextField>;
  return <Box><TextField type="number" fullWidth size="small" label="개선 후 위험점수"
    inputProps={{ min: 1, max: 20 }} value={value || ''} disabled={disabled}
    onChange={event => onChange(event.target.value)} /></Box>;
}
